import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const API = process.env.REACT_APP_BACKEND_URL || "";

const CHEM = ["Boronic acids and esters","Halogenated aromatics","Carbazoles and indolocarbazoles","Triazines and pyrimidines","Boron-nitrogen (MR) cores","Iridium / platinum complexes","Deuterated compounds","Spiro and fluorene systems","Amines and phosphines","Heterocycle construction"];
const CAP = ["Sublimation","Column chromatography","Recrystallisation","Zone refining","Distillation","Trace metal control (ppb)"];
const SCALE = ["Gram","100 g","Kilogram","10 kg","100 kg","Tonne"];

const T = {
  en: { h: "Your capabilities and product list", sub: "This is what we match customer enquiries against. It takes two minutes and it is the single biggest factor in how much work we can send you.",
    chem: "Chemistry types you handle", cap: "Purification available", scale: "Maximum batch scale",
    upT: "Product and raw material list", up: "Upload your existing catalogue, price list or inventory export. Any format, any column order, no reformatting needed. If you already hold the starting materials for a route, your facility is shortlisted first, and that usually carries through to scale-up and repeat orders.",
    cas: "Include CAS numbers if you have them. It is the one thing that most improves your matching.",
    pick: "Choose file (Excel or CSV, max 8 MB)", or: "No file ready? Paste a link to your online catalogue instead",
    conf: "Your product list is stored confidentially, used only to match you to enquiries, and is never shared with other partners or customers.",
    send: "Save capabilities", sending: "Uploading...", done: "Received. We have added your capabilities to the matching list.",
    read: "We read", prods: "products", withCas: "with CAS numbers", bad: "rows we could not read" },
  ko: { h: "보유 역량 및 제품 리스트", sub: "고객 문의를 매칭할 때 사용하는 정보입니다. 2분이면 충분하며, 배정 물량을 좌우하는 가장 큰 요소입니다.",
    chem: "취급 가능한 화학 분야", cap: "보유 정제 설비", scale: "최대 배치 규모",
    upT: "제품 및 원료 리스트", up: "기존 카탈로그, 단가표, 재고 파일을 그대로 올려주세요. 형식이나 열 순서를 맞추실 필요 없습니다. 해당 경로의 출발물질을 이미 보유하고 계시면 우선 검토 대상이 되며, 이는 스케일업과 반복 주문으로 이어집니다.",
    cas: "CAS 번호가 있다면 꼭 포함해 주세요. 매칭 정확도를 가장 크게 높여줍니다.",
    pick: "파일 선택 (Excel 또는 CSV, 최대 8 MB)", or: "파일이 없으시면 온라인 카탈로그 링크를 입력해 주세요",
    conf: "제품 리스트는 기밀로 보관되며 매칭 목적으로만 사용됩니다. 다른 파트너나 고객에게 절대 공유되지 않습니다.",
    send: "역량 정보 저장", sending: "업로드 중...", done: "접수되었습니다. 매칭 목록에 반영했습니다.",
    read: "읽어들인 항목", prods: "개 제품", withCas: "개 CAS 번호 포함", bad: "개 행은 인식 불가" },
  zh: { h: "您的能力与产品清单", sub: "这是我们匹配客户询盘的依据。只需两分钟，却直接决定我们能给您多少订单。",
    chem: "可承接的化学类型", cap: "可用纯化手段", scale: "最大批次规模",
    upT: "产品与原料清单", up: "直接上传现有的产品目录、报价单或库存导出文件。任意格式、任意列顺序，无需重新整理。若您已持有某条路线的起始原料，您的工厂会被优先入围，并通常延续到放大生产与重复订单。",
    cas: "如有 CAS 号请务必包含，这是提升匹配度最有效的一项。",
    pick: "选择文件（Excel 或 CSV，最大 8 MB）", or: "没有现成文件？可粘贴在线产品目录链接",
    conf: "您的产品清单将被保密存储，仅用于匹配询盘，绝不与其他合作伙伴或客户分享。",
    send: "保存能力信息", sending: "上传中...", done: "已收到，您的能力信息已加入匹配列表。",
    read: "已读取", prods: "个产品", withCas: "个含 CAS 号", bad: "行无法识别" },
  de: { h: "Ihre Fähigkeiten und Produktliste", sub: "Damit gleichen wir Kundenanfragen ab. Es dauert zwei Minuten und bestimmt maßgeblich, wie viele Aufträge wir Ihnen zuordnen können.",
    chem: "Chemie, die Sie abdecken", cap: "Verfügbare Reinigung", scale: "Maximaler Ansatz",
    upT: "Produkt- und Rohstoffliste", up: "Laden Sie Ihren vorhandenen Katalog, Ihre Preisliste oder einen Lagerauszug hoch. Beliebiges Format, beliebige Spaltenreihenfolge, kein Umformatieren nötig. Wenn Sie die Ausgangsstoffe bereits vorrätig haben, kommen Sie zuerst in die engere Wahl, meist bis hin zu Scale-up und Folgeaufträgen.",
    cas: "Bitte CAS-Nummern angeben, sofern vorhanden. Nichts verbessert das Matching stärker.",
    pick: "Datei wählen (Excel oder CSV, max. 8 MB)", or: "Keine Datei zur Hand? Link zu Ihrem Online-Katalog einfügen",
    conf: "Ihre Produktliste wird vertraulich gespeichert, ausschließlich zum Abgleich genutzt und niemals an andere Partner oder Kunden weitergegeben.",
    send: "Fähigkeiten speichern", sending: "Wird hochgeladen...", done: "Erhalten. Ihre Angaben sind in der Matching-Liste.",
    read: "Gelesen", prods: "Produkte", withCas: "mit CAS-Nummer", bad: "Zeilen nicht lesbar" },
};

const box = { background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, padding: 22, marginTop: 18 };
const chip = (on) => ({ display: "inline-block", padding: "6px 13px", margin: "0 7px 7px 0", borderRadius: 999, fontSize: 13, cursor: "pointer", border: on ? "1px solid #ea580c" : "1px solid #cbd5e1", background: on ? "#fff7ed" : "#fff", color: on ? "#9a3412" : "#475569" });

export const PartnerCatalog = () => {
  const { i18n } = useTranslation();
  const lang = ((i18n && i18n.language) || "en").slice(0, 2);
  const c = T[lang] || T.en;
  const [chem, setChem] = useState([]);
  const [cap, setCap] = useState([]);
  const [scale, setScale] = useState("");
  const [link, setLink] = useState("");
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  const [err, setErr] = useState("");

  const tog = (arr, set, v) => set(arr.indexOf(v) === -1 ? arr.concat([v]) : arr.filter(function (x) { return x !== v; }));

  async function send(e) {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      const el = e.target.elements.catalog;
      const file = el && el.files ? el.files[0] : null;
      if (file && file.size > 8388608) { setErr("Max 8 MB."); setBusy(false); return; }
      const fd = new FormData();
      fd.append("chemistry", chem.join("; "));
      fd.append("purification", cap.join("; "));
      fd.append("scale", scale);
      fd.append("catalog_url", link);
      fd.append("page", window.location.pathname);
      if (file) fd.append("catalog", file);
      const r = await fetch(API + "/api/partner/catalog", { method: "POST", body: fd });
      const j = await r.json();
      if (j && j.ok) setRes(j); else setErr((j && j.error) || "Upload failed. Please email info@lamko.co.kr.");
    } catch (x) { setErr("Upload failed. Please email info@lamko.co.kr."); }
    setBusy(false);
  }

  return (
    <form onSubmit={send} style={box}>
      <h3 style={{ fontSize: 19, fontWeight: 700, color: "#0f172a", margin: "0 0 6px" }}>{c.h}</h3>
      <p style={{ fontSize: 14, color: "#475569", lineHeight: 1.7, margin: "0 0 16px" }}>{c.sub}</p>

      <div style={{ fontSize: 13, fontWeight: 700, color: "#334155", margin: "0 0 8px" }}>{c.chem}</div>
      <div style={{ marginBottom: 14 }}>{CHEM.map(function (x) { return <span key={x} style={chip(chem.indexOf(x) !== -1)} onClick={function () { tog(chem, setChem, x); }}>{x}</span>; })}</div>

      <div style={{ fontSize: 13, fontWeight: 700, color: "#334155", margin: "0 0 8px" }}>{c.cap}</div>
      <div style={{ marginBottom: 14 }}>{CAP.map(function (x) { return <span key={x} style={chip(cap.indexOf(x) !== -1)} onClick={function () { tog(cap, setCap, x); }}>{x}</span>; })}</div>

      <div style={{ fontSize: 13, fontWeight: 700, color: "#334155", margin: "0 0 8px" }}>{c.scale}</div>
      <div style={{ marginBottom: 18 }}>{SCALE.map(function (x) { return <span key={x} style={chip(scale === x)} onClick={function () { setScale(x); }}>{x}</span>; })}</div>

      <div style={{ background: "#fff7ed", border: "1px solid #fed7aa", borderRadius: 10, padding: 16 }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: "#9a3412", marginBottom: 6 }}>{c.upT}</div>
        <p style={{ fontSize: 13.5, color: "#7c2d12", lineHeight: 1.7, margin: "0 0 8px" }}>{c.up}</p>
        <p style={{ fontSize: 13, color: "#9a3412", fontWeight: 600, margin: "0 0 10px" }}>{c.cas}</p>
        <label style={{ fontSize: 12.5, color: "#7c2d12", display: "block", marginBottom: 4 }}>{c.pick}</label>
        <input type="file" name="catalog" accept=".xlsx,.xls,.csv,.tsv,.txt,.pdf" style={{ fontSize: 13, marginBottom: 10 }} />
        <input value={link} onChange={function (e) { setLink(e.target.value); }} placeholder={c.or}
          style={{ width: "100%", boxSizing: "border-box", border: "1px solid #fdba74", borderRadius: 8, padding: "9px 11px", fontSize: 13 }} />
      </div>

      {res ? (
        <div style={{ marginTop: 14, background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 8, padding: 14 }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: "#166534" }}>{c.done}</div>
          {res.rows ? (
            <div style={{ fontSize: 13, color: "#15803d", marginTop: 6 }}>
              {c.read} {res.rows} {c.prods}, {res.with_cas} {c.withCas}{res.bad ? ", " + res.bad + " " + c.bad : ""}.
            </div>
          ) : null}
        </div>
      ) : null}
      {err ? <p style={{ fontSize: 13, color: "#b91c1c", marginTop: 10 }}>{err}</p> : null}

      <p style={{ fontSize: 12, color: "#64748b", lineHeight: 1.6, marginTop: 12 }}>{c.conf}</p>
      <button type="submit" disabled={busy}
        style={{ marginTop: 12, background: "#ea580c", color: "#fff", fontWeight: 700, padding: "12px 26px", borderRadius: 8, border: "none", cursor: "pointer", fontSize: 15 }}>
        {busy ? c.sending : c.send}
      </button>
    </form>
  );
};

export default PartnerCatalog;
